import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      {/* Floating navbar */}
      <div className="fixed top-0 left-0 right-0 z-50 pt-4 px-4 md:px-8 lg:px-16 pointer-events-none">
        <nav
          className="pointer-events-auto w-full rounded-full px-4 py-2 flex items-center justify-between"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            boxShadow: "0 4px 32px rgba(0,115,229,0.12)",
          }}
        >
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2 font-bold text-base tracking-tight text-black whitespace-nowrap pl-1"
          >
            <span className="w-7 h-7 rounded-full flex items-center justify-center" style={{ backgroundColor: "#D4F419" }}>
              <i className="ri-code-s-slash-line text-black text-sm"></i>
            </span>
            London App Syndicate
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-0.5">
            <Link
              to="/about-us"
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-black rounded-full transition-colors cursor-pointer whitespace-nowrap"
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#FEF7EB")}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = "")}
            >
              About Us
            </Link>
            <Link
              to="/our-services"
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-black rounded-full transition-colors cursor-pointer whitespace-nowrap"
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#FEF7EB")}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = "")}
            >
              Our Services
            </Link>
            <Link
              to="/our-products"
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-black rounded-full transition-colors cursor-pointer whitespace-nowrap"
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#FEF7EB")}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = "")}
            >
              Our Products
            </Link>
          </div>

          {/* CTA + Mobile toggle */}
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate("/contact-us")}
              className="hidden md:flex items-center gap-2 text-white text-sm font-medium px-5 py-2 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              style={{ backgroundColor: "#0073E5" }}
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#005bbf")}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#0073E5")}
            >
              Contact Us
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </nav>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-white transition-transform duration-300 md:hidden ${
          mobileOpen ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ top: "72px" }}
      >
        <div className="overflow-y-auto h-full px-6 py-6 space-y-1">
          <Link
            to="/about-us"
            className="block py-3 text-base font-medium border-b border-gray-100 cursor-pointer"
            onClick={() => setMobileOpen(false)}
          >
            About Us
          </Link>
          <Link
            to="/our-services"
            className="block py-3 text-base font-medium border-b border-gray-100 cursor-pointer"
            onClick={() => setMobileOpen(false)}
          >
            Our Services
          </Link>
          <Link
            to="/our-products"
            className="block py-3 text-base font-medium border-b border-gray-100 cursor-pointer"
            onClick={() => setMobileOpen(false)}
          >
            Our Products
          </Link>
          <div className="pt-4">
            <Link
              to="/contact-us"
              className="flex items-center justify-center gap-2 text-white text-sm font-medium px-5 py-3 rounded-full w-full cursor-pointer"
              style={{ backgroundColor: "#0073E5" }}
              onClick={() => setMobileOpen(false)}
            >
              Contact Us <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
